import '../../../assets/css/earthwooduser.css'
import React, { useState } from "react";
import Leftbar from "../../../elements/Leftbar";
// import Leftbar from "../../Leftsidebar";
import { Editor } from "primereact/editor";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import axios from 'axios';

import { toast } from 'react-toastify';
// import { API_URL } from "../config/global_constants";
import { API_URL } from '../../../config/global_constants';
import "../BulkEmail.css"

const CreatorTemplate = () => {
  const [title, setTitle] = useState("");
  const [subject, setSubject] = useState("")
  const [editorContent, setEditorContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };

  const CreateTemplate = async (e) => {
    e.preventDefault();

    if (!title.trim() || !subject.trim() || !editorContent.trim()) {
      toast.error("Please fill all fields");
      return;
    }

    setLoading(true);

    try {

      const formData = new FormData();
      formData.append("title", title.trim());
      formData.append("subject", subject.trim());
      formData.append("body", editorContent);


      const response = await axios.post(
        `${API_URL}bulkEmail/storeTemplate`,
        formData,
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      toast.success(response.message || "Email template created successfully!");

      // setTimeout(() => {
      window.location.href = "/view-template"
      // }, [1100])

      setTitle("");
      setSubject("");
      setEditorContent("");

    } catch (error) {
      console.error("Error creating template:", error);
      toast.error(error.message || "An error occurred while creating the template.");
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <div className="earthwood-layout">
        <div className="leftbar-wrapper">
          <Leftbar
            showSidebar={showSidebar}
            handleSidebarClose={handleSidebarClose}
          />
        </div>

        <div className="earthwood-user-list">
          <div className="row">
            <div className="col">
              <div className="mb-4">
                {/* <div className="card-header"> */}
                <h5 className="mb-3 font-weight-bold">Create Template </h5>
                {/* </div> */}
                {/* <div className="card-body"> */}
                <div className="row mt-2">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="contract-label">Title *</label>
                      <input
                        type="text"
                        className="form-control Create-template-input"
                        placeholder="Please enter title"
                        onChange={(e) => setTitle(e.target.value)}
                        value={title}
                        disabled={loading}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="contract-label">Subject *</label>
                      <input
                        type="text"
                        className="form-control Create-template-input"
                        placeholder="Please enter subject"
                        onChange={(e) => setSubject(e.target.value)}
                        value={subject}
                        disabled={loading}
                      />
                    </div>
                  </div>
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>

          <div className='mb-2'>
            <label className="contract-label">Email Body *</label>
            <Editor
              value={editorContent}
              onTextChange={(e) => setEditorContent(e.htmlValue)}
              // style={{ height: '320px' }}
              disabled={loading}
            />
          </div>

          <button
            onClick={CreateTemplate}
            disabled={loading}
            className="btn submit-btn-template mt-4 w-15  d-flex justify-content-center align-items-center"
          >
            {loading ? (
              <i className="pi pi-spin pi-spinner" style={{ marginRight: '8px' }}></i>
            ) : null}
            <span>{loading ? "Submitting..." : "Submit"}</span>
          </button>
        </div>
      </div>
    </>
  )
}

export default CreatorTemplate;